<template>
  <section ref="styles" style="display:none !important;" >
    :root{
        --toolbarBackground: {{ vendor.toolbarColor }};
        --footerBackground: {{ vendor.footerColor }};
        --footerTextColor: {{ vendor.footerTextColor }};
        --buttonBackground: {{ vendor.buttonColor }};
        --buttonTextColor: {{ vendor.buttonTextColor }};
        --mapTextColor: {{vendor.textColorMap}};
        --mapCircleColor: {{vendor.circleColorMap}};
        --backCardProduct: {{vendor.productCardBackground || vendor.backCardProduct}};
        --textColorDescriptionCard: {{vendor.productDescriptionColor || vendor.textColorDescriptionCard}};
        --textColorTitleCard: {{vendor.productTitleColor || vendor.textColorTitleCard}};
        --textColorPriceCard: {{vendor.productPriceColor || vendor.textColorPriceCard}};
        --productDiscountTextColor: {{vendor.productDiscountTextColor || '#9faab7'}};
        --productDiscountBadgeBackground: {{vendor.productDiscountBadgeBackground || '#ff2425'}};
        --productDiscountBadgeTextColor: {{vendor.productDiscountBadgeTextColor || '#fff'}};
        --navIconColor: {{ vendor.navIconColor || vendor.buttonTextColor }};
        --backButtonBackground: {{ vendor.backButtonBackground || vendor.buttonColor }};
        --backButtonTextColor: {{ vendor.backButtonTextColor || vendor.buttonTextColor }};
        --cartIconColor: {{ vendor.cartIconColor || vendor.buttonTextColor }};
        --cartBadgeBackground: {{ vendor.cartBadgeBackground || vendor.buttonColor }};
        --cartBadgeTextColor: {{ vendor.cartBadgeTextColor || vendor.buttonTextColor }};
        --searchInputBackground: {{ vendor.searchInputBackground || '#fff' }};
        --searchInputTextColor: {{ vendor.searchInputTextColor || 'inherit' }};
        --searchIconColor: {{ vendor.searchIconColor || '#000' }};
        --searchIconBackground: {{ vendor.searchIconBackground || '#fff' }};
        --searchInputBorderColor: {{ vendor.searchInputBorderColor || 'transparent' }};
        --orderPopupBackground: {{ vendor.orderPopupBackground || '#fff' }};
        --orderPopupTextColor: {{ vendor.orderPopupTextColor || '#000' }};
        --orderPopupInputBackground: {{ vendor.orderPopupInputBackground || '#fff' }};
        --orderPopupInputTextColor: {{ vendor.orderPopupInputTextColor || '#000' }};
        --orderPopupButtonBackground: {{ vendor.orderPopupButtonBackground || vendor.buttonColor }};
        --orderPopupButtonTextColor: {{ vendor.orderPopupButtonTextColor || vendor.buttonTextColor }};
        --orderPopupInputBorderColor: {{ vendor.orderPopupInputBorderColor || '#dbdbdb' }};
        --categoryCardBackground: {{ vendor.categoryCardBackground || '#fff' }};
        --categoryCardBorderColor: {{ vendor.categoryCardBorderColor || 'transparent' }};
        --categoryNameBackground: {{ vendor.categoryNameBackground || vendor.buttonColor }};
        --categoryNameTextColor: {{ vendor.categoryNameTextColor || vendor.buttonTextColor }};
        --subcategoryCardBackground: {{ vendor.subcategoryCardBackground || '#fff' }};
        --subcategoryCardBorderColor: {{ vendor.subcategoryCardBorderColor || '#d3d3d3' }};
        --subcategoryCardTextColor: {{ vendor.subcategoryCardTextColor || '#000' }};
        --subcategoryActiveColor: {{ vendor.subcategoryActiveColor || vendor.buttonColor }};
        --subcategoryCardActiveBackground: {{ vendor.subcategoryCardActiveBackground || '#DDDDDD' }};
        --subcategoryPillBackground: {{ vendor.subcategoryPillBackground || '#f5f5f6' }};
        --subcategoryPillTextColor: {{ vendor.subcategoryPillTextColor || '#000' }};
        --subcategoryPillActiveBackground: {{ vendor.subcategoryPillActiveBackground || vendor.buttonColor }};
        --subcategoryPillActiveTextColor: {{ vendor.subcategoryPillActiveTextColor || vendor.buttonTextColor }};
    }
  </section>
</template>

<script>
export default {
  name: 'CustomVars',
  props: ['vendor'],
  mounted: function () {
    const styleTag = document.createElement('style');
    styleTag.textContent = this.$refs.styles.textContent;
    this.$refs.styles.textContent = null;
    this.$refs.styles.appendChild(styleTag);
  }
};
</script>
